const cleaningSessionStorage = () => {
  sessionStorage.clear();
};
export default cleaningSessionStorage;
